import CasesTable from './cases-table';
export { default as CasesTablePlaceholder } from './cases-table-placeholder';
export default CasesTable;
